import { connect } from 'react-redux';

import { allSpecialFilterKey, isFoodsPage } from '../const';
import { scrollItemsContainerToTop } from '../../utils/utils';
import {
  getFilteredSkus,
  getFilteredRecipes,
  updateSearchText,
  selectSkuCategory,
  selectRecipeDishtype,
} from '../actions_creators';

const Search = (props) => {
  let {
    searchText,
    appliedSearchText,
    updateSearchText,
    selectRecipeDishtype,
    selectSkuCategory,
    getFilteredPairings,
    getFilteredSkus,
  } = props;

  const submitFunc = () => {
    scrollItemsContainerToTop();
    selectRecipeDishtype(allSpecialFilterKey);
    selectSkuCategory(allSpecialFilterKey);
    if (!isFoodsPage) {
      getFilteredPairings();
    }
    getFilteredSkus();
    ga('send', 'event', 'submit-search', 'search');
  };

  const handleOnKeyUp = (evt) => {
    if (evt.key.toUpperCase() === 'ENTER') {
      submitFunc(true);
    }
  };

  const updateAndClear = () => {
    if (searchText) {
      updateSearchText('');
      submitFunc();
      ga('send', 'event', 'clear-search', 'clear');
    }
  };

  let imgSrc = `/public/img/edit_delivery/search_magnifying_glass_${
    appliedSearchText === '' ? 'default' : 'active'
  }.svg`;
  let searchClass =
    appliedSearchText === '' ? 'inactive-search' : 'active-search';
  const recipesTxt = 'Search by recipes and ingredients';
  const groceriesTxt = 'Search by groceries and brands';
  let placeholder = window.location.pathname.endsWith('recipes/')
    ? recipesTxt
    : groceriesTxt;

  return (
    <div className="search-component">
      <div className="search-bar-container">
        <div className="search-wrapper">
          <img
            className="magnifying-glass"
            src={imgSrc}
            alt="Search icon"
            onClick={(_) => submitFunc(true)}
          />
          <input
            data-testid="search-text-input"
            type="text"
            name="search-box"
            value={searchText}
            className={`search-input-box ${searchClass}`}
            placeholder={placeholder}
            onChange={(evt) => updateSearchText(evt.target.value)}
            onKeyUp={(evt) => handleOnKeyUp(evt)}
            tabIndex="0"
            autoComplete="off"
          />
        </div>
        <div
          className={`clear-search-x ${searchText ? 'visible' : 'not-visible'}`}
          onClick={updateAndClear}
        >
          ×
        </div>
      </div>
    </div>
  );
};

let mapStateToProps = (state) => {
  return {
    searchText: state.filters.searchText,
    appliedSearchText: state.filters.appliedSearchText,
  };
};

let mapDispatchToProps = (dispatch) => {
  return {
    getFilteredSkus: (loadMore) => dispatch(getFilteredSkus(loadMore)),
    getFilteredPairings: (loadMore) => dispatch(getFilteredRecipes(loadMore)),
    updateSearchText: (searchText) => dispatch(updateSearchText(searchText)),
    selectRecipeDishtype: (allSpecialFilterKey) =>
      dispatch(selectRecipeDishtype(allSpecialFilterKey)),
    selectSkuCategory: (allSpecialFilterKey) =>
      dispatch(selectSkuCategory(allSpecialFilterKey)),
  };
};

/**
 * @deprecated
 */
export default connect(mapStateToProps, mapDispatchToProps)(Search);
